import Main from './components/main';

export default {
    install(Vue) {
        Vue.component("MinderCase", Main);
    }
};


// WEBPACK FOOTER //
// ./src/export.js